module.exports = __webpack_public_path__ + "img/img_20_brand_retail@3x.778436be.png";